var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blog_1_",
    "data-name": "blog (1)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.586,
    height: 26.265,
    viewBox: "0 0 29.586 26.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.859,
    y1: 0.901,
    x2: 0.06,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M81.156,285.576h3.467a1.156,1.156,0,1,0,0-2.311H81.156a1.156,1.156,0,0,0,0,2.311Z",
    transform: "translate(-75.377 -268.557)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M81.156,205.576h3.467a1.156,1.156,0,1,0,0-2.311H81.156a1.156,1.156,0,1,0,0,2.311Z",
    transform: "translate(-75.377 -193.18)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M217.441,44.6a1.156,1.156,0,0,0,1.156,1.156,8.988,8.988,0,0,0,6.4-2.65l8.452-8.452a3.467,3.467,0,1,0-4.9-4.9L220.091,38.2A8.988,8.988,0,0,0,217.441,44.6Zm12.736-13.215a1.156,1.156,0,1,1,1.634,1.634L223.36,41.47a6.688,6.688,0,0,1-3.487,1.853,6.689,6.689,0,0,1,1.853-3.487Z",
    transform: "translate(-204.876 -28.735)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M3.467,106.379a3.462,3.462,0,0,0,2.311-.882l1.6-1.429H19.184a5.785,5.785,0,0,0,5.778-5.778V95.7a1.156,1.156,0,0,0-2.311,0v2.592a3.471,3.471,0,0,1-3.467,3.467H6.934a1.156,1.156,0,0,0-.77.294l-1.926,1.723a1.156,1.156,0,0,1-1.926-.862V89.043a3.471,3.471,0,0,1,3.467-3.467h9.693a1.156,1.156,0,0,0,0-2.311H5.778A5.785,5.785,0,0,0,0,89.043v13.868A3.471,3.471,0,0,0,3.467,106.379Z",
    transform: "translate(0 -80.114)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.9f0de9ef3371c70a47a3262ad9ab488a.svg";
export { ForwardRef as ReactComponent };